module.exports = __webpack_public_path__ + "media/dog_web.c464ee8c.mp4";